import MarketPageLayout from './MarketPageLayout';

export default MarketPageLayout;